export const spbpDescText = [
   {
    "000": {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
            SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      DEFAULT: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    DEFAULT: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays:",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays:",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    879: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Chosen",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees, related search expenses and all applicable closing fees.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "In exchange for using the Seller's preferred title partner and closing agent, Seller agrees to pay the closing fee on behalf of the Buyer up to $450.00. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
            SELLER_PAYS: {
            label: "Seller Preferred",
            text: "In exchange for using the Seller's preferred title partner and closing agent, Seller agrees to pay the closing fee on behalf of the Buyer up to $450.00. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
          BUYER_PAYS: {
            label: "Buyer Chosen",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees, related search expenses and all applicable closing fees.",
          },
         
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Chosen",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    886: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: " Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
       COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    870: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: " Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: " Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: " Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: " Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses. ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
       COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    856: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: " Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: " Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: " Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: " Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " ",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: " Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
       COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    888: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
       COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    860: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
       COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    884: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
       COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    890: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
       COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    900: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
       COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    894: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    895: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    896: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    898: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID##  is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID##  is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID##  is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID##  is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID##  is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID##  is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID##  is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID##  is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID##  is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID##  is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID##  is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    899: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in  ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in  ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in  ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in  ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    901: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer Pays: Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    885: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the Seller's preferred title insurance provider and closing agent. This lets the buyer bypass the title insurance fees and most of the related search costs (some search and ancillary fees may be charged to the Buyer in some jurisdictions as determined by Seller's preferred title provider), as well as 50% of the escrow and closing fees up to $550, because the seller will contribute to the payment of these charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees, related search expenses and all applicable closing fees.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the Seller's preferred title insurance provider and closing agent. This lets the buyer bypass the title insurance fees and most of the related search costs (some search and ancillary fees may be charged to the Buyer in some jurisdictions as determined by Seller's preferred title provider), as well as 50% of the escrow and closing fees up to $550, because the seller will contribute to the payment of these charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    904: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the Seller's preferred title insurance provider and closing agent. This lets the buyer bypass the title insurance fees and most of the related search costs (some search and ancillary fees may be charged to the Buyer in some jurisdictions as determined by Seller's preferred title provider), as well as 50% of the escrow and closing fees up to $550, because the seller will contribute to the payment of these charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges.  Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    909: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer Pays: Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##</b>. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges.  Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: " Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and save on escrow/closing fees, the seller will cover the charges for the title insurance policy and some or most of the escrow/closing fees. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    914: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "NA",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    915: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##. Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    916: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer agrees to use the Seller's preferred title partner and closing agent. The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    501: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer selects a closing/escrow agent and title provider of their choice and pays all associated fees and expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer selects a closing/escrow agent and title provider of their choice and pays all associated fees and expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer selects a closing/escrow agent and title provider of their choice and pays all associated fees and expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer selects a closing/escrow agent and title provider of their choice and pays all associated fees and expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    917: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees and related search costs, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Preferred",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
  {
    155: {
      REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SHRT_SALE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      NON_REO: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      FORECLOSURE: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      SC: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      ABS: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      DEFAULT: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
      COMMERCIAL: {
        CASH: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
        MORTGAGE: {
          BUYER_PAYS: {
            label: "Buyer Pays",
            text: "Buyer uses their <b>own title partner</b> and <b>closing agent</b> without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.",
          },
          SELLER_PAYS: {
            label: "Seller Pays",
            text: "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. <b>The standard charge for title insurance services in ##STATEID## is ##AMOUNT##.</b> Please note that buyers making all-cash purchases are automatically opted in to save through this method.",
          },
        },
      },
    },
  },
];
